import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import React from 'react';
import { useState } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';

import StbGreatek from '../../../assets/images/stb_greatek.jpg';
import StbInfomir from '../../../assets/images/infomir.jpg';
import StbAlbis from '../../../assets/images/albis.jpg';
import StbProeletronic from '../../../assets/images/proeletronic.jpg';
import StbFiberhome from '../../../assets/images/fiberhome.jpg';

import * as FaIcons from "react-icons/fa";
import * as ImIcons from "react-icons/im";

import './styles.css';

function Stbs() {

    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [showModal4, setShowModal4] = useState(false);

    const handleCloseModal1 = () => setShowModal1(false);
    const handleCloseModal2 = () => setShowModal2(false);
    const handleCloseModal3 = () => setShowModal3(false);
    const handleCloseModal4 = () => setShowModal4(false);

    const handleOpenModal1 = () => setShowModal1(true);
    const handleOpenModal2 = () => setShowModal2(true);
    const handleOpenModal3 = () => setShowModal3(true);
    const handleOpenModal4 = () => setShowModal4(true);

    return (
        <>
            <Card className='altura'>
                <Card.Title><h1>Dúvidas frequentes</h1></Card.Title>
                <Card.Body>
                    <div className='basic-card px-2'>
                        <div className='row  py-4'>
                            <div className='col-sm-12 col-md-4'>
                                <Card>
                                    <Card.Header><ImIcons.ImDisplay /> STB - Set-Top box Greatek </Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={StbGreatek} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Sistema operacional Android 7.1.2</li>
                                                        <li>Processador RK3229 Quad-core Cortex-A7 1.5GHZ </li>
                                                        <li>GPU: Mali-400 5 Core</li>
                                                        <li>SDRAM: 1GB DDR</li>
                                                        <li>Armazenamento  8 GB eMMC</li>
                                                        <li>Adaptador de energia 5V 2A</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal1}>+ Informações</Button>
                                        <Modal show={showModal1} onHide={handleCloseModal1} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre Set-Top box Greatek</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <h5>Instruções:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Produto em comodato</ListGroup.Item>
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal1}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://www.grupogreatek.com.br/wp-content/uploads/2023/02/dsheet_stband001.pdf" target="_blank"> <Button variant="dark">Especificações Técnicas </Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-sm-12 col-md-4'>
                                <Card>
                                    <Card.Header><ImIcons.ImDisplay /> STB - Set-Top box Infomir</Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={StbInfomir} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Sistema operacional	Linux 4.9 </li>
                                                        <li>Processador	ARM Cortex-A53 Quad-core, 1,900 MHz </li>
                                                        <li>Chipset	Amlogic S905X2</li>
                                                        <li>RAM	1 GB</li>
                                                        <li>Armazenamento 4 GB eMMC</li>
                                                        <li>Adaptador de energia 5V 2A</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal2}>+ Informações </Button>
                                        <Modal show={showModal2} onHide={handleCloseModal2} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre Set-Top box Infomir</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <h5>Instruções:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Produto em comodato</ListGroup.Item>
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal2}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://www.infomir.eu/prt/products/iptv-stb/mag524/" target='_blank'> <Button variant="dark">Especificações Técnicas</Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>

                            <div className='col-sm-12 col-md-4'>
                                <Card>
                                    <Card.Header><ImIcons.ImDisplay /> STB - Set-Top box Albis </Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={StbAlbis} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Sistema operacional	 Linux® 3.4</li>
                                                        <li>Chipset: StiH206 700 MHz</li>
                                                        <li>RAM	512MB DDR3</li>
                                                        <li>Armazenamento Flash memory: 128 MB NAND, 2 MB NOR</li>
                                                        <li>Adaptador de energia 12V 1A</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal3}>+ Informações</Button>
                                        <Modal show={showModal3} onHide={handleCloseModal3} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre Set-Top box Albis</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <h5>Instruções:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Produto em comodato</ListGroup.Item>
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal3}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://www.albis-elcon.com/wp-content/uploads/2017/09/Data-sheet-SceneGate-8073-en.pdf" target="_blank"> <Button variant="dark">Especificações Técnicas </Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-sm-12 col-md-4'>
                                <Card>
                                    <Card.Header><ImIcons.ImDisplay /> STB - Set-Top box Proeletronic</Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={StbProeletronic} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Sistema operacional	Android 10 OASP </li>
                                                        <li>Arm Cortex A53 64 BITS / MALI-G31 OpenGL 3.2 </li>
                                                        <li>RAM	2GB DDR3</li>
                                                        <li>Armazenamento 16GB</li>
                                                        <li>Adaptador de energia 5V 2A</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal4}>+ Informações </Button>
                                        <Modal show={showModal4} onHide={handleCloseModal4} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre Set-Top box Proeletronic</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <h5>Instruções:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Produto em comodato</ListGroup.Item>
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal4}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://proeletronic.com.br/wp-content/uploads/2023/02/Especificacoes-PROSB-3000_16GB-_SMARTPRO-4K_REV00.pdf" target='_blank'> <Button variant="dark">Especificações Técnicas</Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>

                            <div className='col-sm-12 col-md-4'>
                                <Card>
                                    <Card.Header><ImIcons.ImDisplay /> STB - Set-Top Fiberhome </Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={StbFiberhome} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Sistema operacional	 Android 9</li>
                                                        <li>CPU: Amlogic S905X ARM Cortex A53 Quad core,
                                                            64bit</li>
                                                        <li>GPU: Mali 450 Penta core</li>
                                                        <li>Armazenamento Flash : 8GB eMMC</li>
                                                        <li>RAM : 1GB/2GB DDR4</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal3}>+ Informações</Button>
                                        <Modal show={showModal3} onHide={handleCloseModal3} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre Set-Top box Fiberhome</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <h5>Instruções:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Produto em comodato</ListGroup.Item>
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Ligar na rede cabeada</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão na porta 2 do modem(ONU) </ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal3}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://wdcnet.com.br/wp-content/uploads/2023/03/SETUP-BOX-Brochure-HG680-PM-3.pdf" target="_blank"> <Button variant="dark">Especificações Técnicas </Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-sm-12 col-md-4'>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
            <div className="end">
            </div>
        </>
    );
}
export default Stbs;